export default "__VITE_ASSET__BmbYw9rN__"